import React from 'react';

interface Service {
  title: string;
  description: string;
  icon: string;
}

interface ServicesSectionProps {
  title: string;
  services: Service[];
}

const ServicesSection = ({ title, services }: ServicesSectionProps) => {
  return (
    <section className="py-16 bg-gray-900">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold text-white text-center mb-12">{title}</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-gray-800 p-6 rounded-lg">
              <div className="text-gold text-3xl mb-4">
                {service.icon === 'plane' && '✈️'}
                {service.icon === 'jet' && '🛩️'}
                {service.icon === 'briefcase' && '💼'}
                {service.icon === 'clock' && '⏰'}
              </div>
              <h3 className="text-xl font-semibold text-white mb-2">{service.title}</h3>
              <p className="text-gray-300">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
